/**
 * Shared sessionStorage cache for Algolia Recommend API responses.
 * Key: model + objectID (or 'global' for trending) + locale.
 * TTL: 5 minutes (configurable).
 */
const ALGOLIA_CACHE_TTL = 5 * 60 * 1000;
const ALGOLIA_CACHE_PREFIX = 'alg_rec_';

window.__algoliaRecommendCache = {
  _key(parts) {
    const locale = document.documentElement.lang || 'en';
    return ALGOLIA_CACHE_PREFIX + locale + '_' + parts.join('_');
  },

  get(parts) {
    const key = this._key(parts);
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      const entry = JSON.parse(raw);
      if (Date.now() > entry.exp) {
        sessionStorage.removeItem(key);
        return null;
      }
      return entry.data;
    } catch {
      return null;
    }
  },

  set(parts, data) {
    const key = this._key(parts);
    try {
      sessionStorage.setItem(key, JSON.stringify({
        data,
        exp: Date.now() + ALGOLIA_CACHE_TTL,
      }));
    } catch {
      // sessionStorage full — silently fail
    }
  },
};
